module.exports = __webpack_public_path__ + "static/media/hail.acf2bb74.svg";